const MenuItemDivider = () => {
    return <span className="menu-divider" />
}

export default MenuItemDivider
